<div class="privacy-consent-status-chip-component {{toClass()}}">
  {{status}}
</div>